import { SignupForm } from "@/components/SignupForm";
import { HOME } from "@/constants/testIds";

export const DiscountBand = () => (
  <section data-testid={HOME.discountBand} className="max-w-7xl mx-auto px-6 lg:px-10 mt-24">
    <div className="bg-[#1C1917] text-white rounded-[2rem] p-8 md:p-12 grid md:grid-cols-2 gap-8 items-center">
      <div>
        <h2 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">Want 10% off? Obviously.</h2>
        <p className="mt-4 text-white/70">Drop your email (and phone if you want texts). You'll get your code, plus first dibs on new drops. No spam. We're too busy packing treats.</p>
      </div>
      <SignupForm source="discount" cta="Send my 10% off code" withPhone />
    </div>
  </section>
);
